import "./event.css";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

import useEventData from "./useEventData";
import Preloader from "../../components/preloader/preloader";

const Event_v2 = () => {
  const [eventsArrFromAPI] = useEventData();
  const [events_arr, setEvents_arr] = useState(null);

  useEffect(() => {
    if (eventsArrFromAPI.length) {
      setEvents_arr(eventsArrFromAPI);
      // console.log(eventsArrFromAPI);
    }
  }, [eventsArrFromAPI]);

  function sendData({ id, venue }) {
    // console.log(eventObj);
    localStorage.setItem("id", id)
    localStorage.setItem("venueId",  venue.id)
    // console.log(venue.id)
  }

  return (
    <>
      {/* <PrimarySearchAppBar /> */}
      {events_arr ? (
        <>
          <div className="spacer"></div>
          <h1 className="text-center">UPCOMING EVENTS</h1>
          {/* <div className="underline">
            <hr />
            <div className="redLine"></div>
          </div> */}

          <section className="grid-of-events wrapper ">
            {events_arr.map(({ id, poster, name, summary, venue }, i) => (
              <div className="individual__event" key={i}>
                <div className="event_image_wrapper">
                  <img className="eventImage" src={poster} alt={name} />
                  <Link
                    to="/EventSingle"
                    className="book_tickets_btn"
                    onClick={() => {
                      sendData({
                        id, venue
                      });
                    }}
                  >
                    Book Now
                  </Link>
                </div>
                <p className="eventName text-center">{name}</p>
              </div>
            ))}
          </section>
        </>
      ) : (
        <Preloader />
      )}
    </>
  );
};

export default Event_v2;
